import React from "react";

class CatalogusGebruikers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gebruikers: [],
    };
    this.handleClickChange = this.handleClickChange.bind(this);
  }

  handleClickChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleEvent() {
    this.state = {
      gebruikers:
        this.props.gebruikers.length > 0 ? this.props.gebruikers : [],
    };
  }

  async componentDidMount() {}

  render() {
    this.handleEvent();
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="gebieden-catalogus-gebruikers"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Gebruikers van dit gebied</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              {this.state.gebruikers && this.state.gebruikers.map((user) => (
                <div className="gebruikers-list-directievoerder">
                  <div className="gebruikers-content">
                    <span className="gebruikers-ico"></span>
                    <div className="gebruikers-name">
                      {user.relationships.related_instance.name}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default CatalogusGebruikers;
